import dayjs from "dayjs";
import { pluralize } from "../../../BookingForm/components/utils";

type History = {
  status: string;
  createdAt: string;
};

export const getDaysSinceInProgress = (history: History[]): string => {
  if (!Array.isArray(history) || history.length === 0) return "--";

  const hasCompleted = history.some((h) => h.status === "completed");
  const inProgress = history.find((h) => h.status === "in_progress");

  if (!inProgress || hasCompleted) return "--";

  const daysDiff = dayjs().diff(dayjs(inProgress.createdAt), "day");

  return daysDiff > 0 ? pluralize(daysDiff, "day") : "Today";
};
